import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Button } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
import Iconify from '../components/iconify';
import AddVideoForm from '../components/AddVideoForm';
import { useNavigate } from 'react-router-dom';
// sections

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  // maxWidth: 1000,
  margin: 'auto',
  maxHeight: '100vh',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(2, 0, 0, 0),
}));

// ----------------------------------------------------------------------

export default function AddVideoPage() {
  const navigate = useNavigate()
  const mdUp = useResponsive('up', 'md');

  const handleBack = () => {
    navigate('/dashboard/videos')
  }

  return (
    <>
      <Helmet>
        <title> Add Video | Video CMS</title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />
        <Button variant="contained" style={{ backgroundColor: "#00A651", maxHeight: "40px" }} onClick={handleBack}>Back</Button>
        <Container maxWidth="lg" textAlign="center">
          <StyledContent>
            <Typography variant="h4" mb={4}>
              Add New Video
            </Typography>
            <AddVideoForm></AddVideoForm>
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
